import * as React from 'react';
import '@geoman-io/leaflet-geoman-free';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
import LeafletPMControl from 'common/components/core/leaflet/LeafletPMControl';

class LeafletPM extends React.PureComponent {
    render() {
        return <LeafletPMControl {...this.props} />;
    }
}
LeafletPM.defaultProps = {
    position: 'topleft' // toolbar position, options are 'topleft', 'topright', 'bottomleft', 'bottomright'
};
export { LeafletPM as LeafletMap };
export default LeafletPM;
